module.exports = __webpack_public_path__ + "img/shade.0447f7ca.png";